import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, mediaUrl, money, apiErr } from "@/lib/api";
import { Table, Button, Badge, Empty, SortControl, sortRows } from "@/lib/ui";

export default function InstagramSchedule() {
  const [tab, setTab] = useState("pending");
  const [rows, setRows] = useState([]);
  const [sort, setSort] = useState({ field: "product", dir: "asc" });
  const SORT_FIELDS = [
    { key: "product", label: "Product", type: "str" },
    { key: "category", label: "Category", type: "str" },
    { key: "company_name", label: "Seller", type: "str" },
    { key: "city", label: "City", type: "str" },
    { key: "discount", label: "Discount", type: "num" },
  ];

  const load = (t = tab) => api.get("/admin/instagram-schedule", { params: { status: t } }).then(({ data }) => setRows(data));
  useEffect(() => { load(); }, [tab]);

  const complete = async (id) => {
    try { await api.post(`/admin/instagram-schedule/${id}/complete`); toast.success("Moved to Completed"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const download = (url, name) => {
    if (!url) { toast.error("No media"); return; }
    const a = document.createElement("a"); a.href = mediaUrl(url); a.download = name; a.target = "_blank"; a.click();
  };

  return (
    <div>
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Instagram Schedule</h1>
      <p className="mt-1 text-sm text-slate-500">Approved products enter this queue automatically.</p>

      <div className="mt-4 flex gap-2">
        {[["pending", "Pending"], ["completed", "Completed"]].map(([k, t]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`insta-tab-${k}`}
            className={`rounded-lg px-4 py-2 text-sm font-semibold ${tab === k ? "bg-slate-900 text-white" : "bg-white text-slate-600 border border-slate-200"}`}>{t}</button>
        ))}
      </div>

      <div className="mt-3"><SortControl fields={SORT_FIELDS} value={sort} onChange={setSort} testid="insta-sort" /></div>

      {rows.length === 0 ? <div className="mt-6"><Empty text="Queue is empty" icon="fa-instagram" /></div> : (
        <div className="mt-4">
          <Table head={["Photo", "Product", "Category", "Seller", "City", "Discount", tab === "pending" ? "Approved" : "Completed", "Actions"]}>
            {sortRows(rows, SORT_FIELDS, sort).map((r) => (
              <tr key={r.id} data-testid={`insta-row-${r.id}`}>
                <td className="px-4 py-2"><img src={mediaUrl(r.catalogue_image)} className="h-12 w-12 rounded object-cover" alt={r.product} /></td>
                <td className="px-4 py-3 font-semibold">{r.product}<div className="text-xs text-slate-400">{r.size}</div></td>
                <td className="px-4 py-3">{r.category}</td>
                <td className="px-4 py-3">{r.company_name}<div className="text-xs capitalize text-slate-400">{r.seller_type}</div></td>
                <td className="px-4 py-3">{r.city}</td>
                <td className="px-4 py-3">{r.discount}%</td>
                <td className="px-4 py-3 text-slate-500">{tab === "pending" ? new Date(r.approved_at).toLocaleDateString() : `${new Date(r.completed_at).toLocaleDateString()} · ${r.completed_by || ""}`}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap gap-1">
                    <Button variant="outline" onClick={() => download(r.catalogue_image, `${r.product}-photo`)} data-testid={`dl-photo-${r.id}`}><i className="fa-solid fa-image" /></Button>
                    <Button variant="outline" onClick={() => download(r.stock_video, `${r.product}-video`)} data-testid={`dl-video-${r.id}`}><i className="fa-solid fa-video" /></Button>
                    {tab === "pending" && <Button variant="green" onClick={() => complete(r.id)} data-testid={`insta-complete-${r.id}`}>Completed</Button>}
                  </div>
                </td>
              </tr>
            ))}
          </Table>
        </div>
      )}
    </div>
  );
}
